import * as React from 'react'
import { FC } from 'react'

import { AddPaymentMethodForm } from './AddPaymentMethodForm'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import { ENTITY_TYPES } from '@sales-center/common'
import Typography from '@mui/material/Typography/Typography'
import IconButton from '@mui/material/IconButton/IconButton'
import CloseIcon from '@mui/icons-material/Close'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  locationId: string
  onClose: () => void
  open: boolean
}

export const AddPaymentMethodDialog: FC<Props> = (props: Props) => {
  const { entityId, entityType, locationId, onClose, open } = props

  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth={'sm'}
      scroll="paper"
      PaperProps={{
        sx: {
          minWidth: {
            xs: '90vw',
            sm: '501px',
          },
          maxHeight: '100vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 0,
          height: '72px',
          pl: '24px',
          pr: '15px',
        }}
      >
        <Typography
          variant={'h6'}
          sx={{
            color: (theme) => theme.palette.text.primary,
          }}
        >
          Capture Card
        </Typography>

        <IconButton
          onClick={onClose}
          size={'medium'}
          sx={{
            color: (theme) => theme.palette.action.active,
            cursor: 'pointer',
            borderRadius: '100px',
          }}
          data-testid="action-modal-close-btn"
          data-test-id="addPaymentMethodDialogCloseBtn"
        >
          <CloseIcon fontSize={'medium'} />
        </IconButton>
      </DialogTitle>
      <AddPaymentMethodForm
        entityId={entityId}
        entityType={entityType}
        locationId={locationId}
        onClose={onClose}
      />
    </Dialog>
  )
}

AddPaymentMethodDialog.displayName = 'AddPaymentMethodDialog'
